// extracted by mini-css-extract-plugin
export var comments = "Response-module--comments--ab476";
export var container = "Response-module--container--abcbd";
export var flag = "Response-module--flag--fec62";
export var inCube = "Response-module--inCube--718a1";
export var loadingIndicator = "Response-module--loadingIndicator--49812";
export var missingName = "Response-module--missingName--bc03c";
export var notInCube = "Response-module--notInCube--6e71a";
export var rating = "Response-module--rating--2e9ca";
export var ratings = "Response-module--ratings--fccfb";
export var title = "Response-module--title--4af44";
export var unrated = "Response-module--unrated--7aa9c";